import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { favouriteOrSelectProductAPI } from "../api/api";
import { startApplicationAPI } from "../api/endpoints/ApiApply";
import useErrorHandler from "../../common/hooks/useErrorLogger";
import IAPICaseProducts from "../interfaces/api/IAPICaseProduct";
import Loader from "../../common/components/Loader/Loader";

type ValidRedirect = {
    groupId: string;
    productId: string;
    caseProduct: string; // {caseID}:{productID},{caseID}:{productID}
};

const ApplyRedirectPage: React.FC<RouteComponentProps<ValidRedirect>> = (props) => {
    const [redirectUrl, setRedirectUrl] = useState("");
    const ErrorLogger = useErrorHandler();

    const params = new URLSearchParams(props.location.search);

    const groupId = params.get("groupId");
    ErrorLogger.SetUserData(groupId);
    // There might be a better way to do this, however it will have to be in the URL?
    const caseProduct = params.get("caseProduct");
    const providerId = params.get("providerId");

    const isValid = caseProduct && providerId && groupId;

    const [hasError, setHasError] = useState("");

    setTimeout(() => {
        setHasError("Timed Out");
    }, 60000);

    useEffect(() => {
        if (isValid) {
            const caseProductList: IAPICaseProducts[] = caseProduct
                .split(",")
                .map((s) => {
                    const [rawCaseId, rawProductId] = s.split(":");
                    const caseId = parseInt(rawCaseId);
                    const productId = parseInt(rawProductId);

                    if (caseId <= 0 || productId <= 0) {
                        ErrorLogger.Log(
                            new Error(
                                `Bypassing invalid case/product tuple with IDs ${caseId}, ${productId}`
                            ),
                            {
                                source: "Apply Redirect"
                            }
                        );
                        return null;
                    }

                    return {
                        caseId: caseId,
                        productId: productId
                    };
                })
                .filter((s) => s);

            // We log that the product has been selected
            const selectionUpdate = caseProductList.map((s) =>
                favouriteOrSelectProductAPI(groupId, s.caseId, s.productId, true, false)
            );

            Promise.all(selectionUpdate)
                .then(() =>
                    startApplicationAPI(groupId, parseInt(providerId), caseProductList)
                        .then((res) => setRedirectUrl(res))
                        .catch((err) => {
                            setHasError(err);
                        })
                )
                .catch((err) => {
                    setHasError(err);
                });
        } else {
            setRedirectUrl("/apply");
        }
    }, [caseProduct, providerId, groupId]);

    if (!redirectUrl) {
        return <Loader size="full-page" />;
    }
    if (hasError) {
        window.location.replace("/404");
    }

    // We use this as it removes the current url from the history, so they can't 'back' to the loading screen.
    window.location.replace(redirectUrl);

    return null;
};

export default ApplyRedirectPage;
